export default __webpack_public_path__ + "images/nvent-brand-schroff.png?109cc30f1238a6f979d5d5369319c954";